<div class="admin-optimisation-task-details">
  <h2>Optimisation tasks details</h2>
  <button class="btn btn-primary pt-2 pb-2 m-1" (click)="updateOptTasksDetails()">Refresh</button>
  <button class="btn btn-primary pt-2 pb-2 m-1" (click)="enableAllOptTasks()">Enable All</button>
  <button class="btn btn-primary pt-2 pb-2 m-1" (click)="disableAllOptTasks()">Disable All</button>
  <button class="btn btn-primary pt-2 pb-2 m-1" (click)="resetAllOptTasks()">Reset All</button>
  <input class="form-control" type="text" [(ngModel)]="searchText" placeholder="Search by store id, name or task status">
  <table class="table">
    <thead>
      <tr>
        <th>Store ID</th>
        <th>Store name</th>
        <th>Status</th>
        <th>Last complete</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (optTaskDetails of optTasksDetails | optTaskFilter:searchText; track optTaskDetails) {
        <tr>
          <td>{{optTaskDetails.storeId}}</td>
          <td>{{optTaskDetails.storeName}}</td>
          <td>{{optTaskDetails.status}}</td>
          <td>{{optTaskDetails.lastComplete}}</td>
          <td>
            @if (optTaskDetails.status !== 'disabled') {
              <button type="button" class="btn btn-primary me-1"
                (click)="disableOptTask(optTaskDetails.storeId)">disable
              </button>
            }
            @if (optTaskDetails.status !== 'idle') {
              <button type="button" class="btn btn-primary me-1"
                (click)="enableOptTask(optTaskDetails.storeId)">enable
              </button>
            }
            <button type="button" class="btn btn-primary me-1" (click)="resetOptTask(optTaskDetails.storeId)">reset
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>